import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm7.5 9.5L10.5 15H13v-4h2v4h2.5L14 18.5z"
}), 'SwapVerticalCircleSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SwapVerticalCircleSharp.js
// module id = 6621
// module chunks = 2